import React, { useEffect, useState } from "react";
import Select from "@atlaskit/select";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

const ActionSelectList = ({ action, onClickCallback }) => {
  const flow = useSelector((state) => state.integration.flow);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");

  const dispatch = useDispatch();
  const { sectionId = "" } = useParams();


  useEffect(() => {
    const options = [];
    if (flow.actions) {
      flow.actions
        .forEach((a) => {
          options.push({ label: a.name, value: a.id });
        });
    }
    setOptions(options);
    setSelectedOption(options.find(o=>o.value === sectionId));
  }, [flow, action, sectionId]);

  
  const handleOnChange = (e) => {
    setSelectedOption(e);
    onClickCallback(e.value)
  };


  return (
    <>
        <Select
          className="ihub-actionmenu-move-select"
          options={options}
          value={selectedOption}
          spacing="compact"
          isRequired={true}
          onChange={handleOnChange}
          name="actionPicker"
        /> 
    </>
  );
};
export default ActionSelectList;
